import styled from 'styled-components'

const Button1 = styled.button`
  background: black;
  display: inline-block;
  padding: 0.35em 1.2em;
  margin-top: 15px;
  margin-left: 125px;
  border: 0.1em solid #FFFFFF;
  border-radius: 0.12em;
  box-sizing: border-box;
  text-decoration: none;
  font-family: 'Roboto',sans-serif;
  font-size: 1em;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  transition: all 0.2s;
  :hover{
    color: red;
  }
`;

export default Button1;
